import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Checkbox, Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 ,FileInput} from "@blueprintjs/core";
import { Classes, Card, Elevation, Divider } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";


import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from './svg/wait2.gif'

import { Account,Document } from './Types'
import { SystemHeader } from './CommonUI';
import { Pagination, PageInfo } from './CommonUI';

import i18next from 'i18next';
 

var GsbFlag: any;

var UserID: string;
var PgmCode = "M0001" ;
var isReqAuth2:boolean = false ;

interface ClientAuthorPersonViewProps {
    gsb: AxiosInstance,
    ac: Account,// FBSAccount,
    //ac0: FBSAccount,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,   
} 
export function ClientAuthorPersonView({ gsb, ac = {} as Account, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { }}: ClientAuthorPersonViewProps) {

//export function ClientAuthorPersonView({ gsb,ac,onEdit = () => { }}: ClientAuthorPersonViewProps) {


    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)

    const [AuthUser, setAuthUser] = useState("")
    const [password, setPassword] = useState("")

  
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")


    const [isUploadDocPress, setisUploadDocPress] = useState(false)
    const [reloadDoc, setreloadDoc] = useState(false)
    const [docList, setDocList] = useState([] as Document[])
    const [isManageClientDoc, setisManageClientDoc] = useState(false)
    const [currentMode, setCurrentMode] = useState("show")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
    
    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            //setisReqAuth(true)
                            //isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, ac])


    const onReqViewClientDoc = () => {
        (async () => {
            try {
                const res2 = await gsb.post('/PgmAccess', {
                    userId: AuthUser,
                    password: password,
                    cIPAddr: "",
                    cReqUser: GsbFlag.UserID,
                } )
                if (res2.data.ok) {
                    setAuthUser("")
                    setPassword("")

                    const res = await gsb.post('/Master', {
                        sb_data: {
                            userId: AuthUser,
                            password: password,
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "ReqUserGroupAccessReqAuth"
                    })
                    console.log("onReqAuthDelRec res.data.data", res.data.data);
                    if ( res.data.ok && res.data.data[0].d_Can_ViewClientDoc == "Y") {
                       // setshowClientDoc(true);
                        
                    } else {
                        utils.showWarn("Authorization failed")
                        setisShowAlert2(true)
                        setShowAlert2Msg("Authorization failed")
                    }

                } else {
                    utils.showError(res2.data.message)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res2.data.message)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()

    }

    const onReqManageClientDoc = () => {
        (async () => {
            try {
                const res2 = await gsb.post('/PgmAccess', {
                    userId: AuthUser,
                    password: password,
                    cIPAddr: "",
                    cReqUser: GsbFlag.UserID,
                } )
                if (res2.data.ok) {
                   setAuthUser("")
                   setPassword("")

                    const res = await gsb.post('/Master', {
                        sb_data: {
                            userId: AuthUser,
                            password: password,
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "ReqUserGroupAccessReqAuth"
                    })
                    console.log("onReqAuthDelRec res.data.data", res.data.data);
                    if ( res.data.ok && res.data.data[0].d_Can_ManageClientDoc == "Y") {
                        setisManageClientDoc(true);
                        
                    } else {
                        utils.showWarn("Authorization failed")
                       setisShowAlert2(true)
                        setShowAlert2Msg("Authorization failed")
                    }

                } else {
                    utils.showError(res2.data.message)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res2.data.message)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

  //  if (! ("d_acCode" in ac)) return null onEdit = () => { }
  // if (! ("d_acCode" in ac)) return null

    return (
            <>

            <div className="Row">
                {/*<Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>*/}
                
                {/*<Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>*/}
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                {/*
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>*/}
                
                {/*<Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>*/}
               
           
       
            </div>

            <div className="Spacing-V-16" />
            <div className="Row">
            </div>

            <div className="Row">
                <FormGroup className="Col-1-1" label="Account" labelFor="d_acCode" labelInfo="*">
                    <InputGroup  id="d_acCode" name="d_acCode" readOnly value={ac.d_acCode} />        
                </FormGroup>
                <FormGroup className="Col-2-3" label="Name" labelFor="d_Name">
                    <InputGroup id="d_Name" name="d_Name"  readOnly value={ac.d_acName1}/>                 
                    <InputGroup id="d_Name2" name="d_Name2"  readOnly value={ac.d_acName2} />  
                </FormGroup> 
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="Name1" labelFor="Name1">
                    <InputGroup id="d_A_Name1" name="d_A_Name1" readOnly value={ac.d_A_Name1}/>   
                    <InputGroup id="d_A_Name2" name="d_A_Name2" readOnly value={ac.d_A_Name2}/>   
                    <InputGroup id="d_A_Name3" name="d_A_Name3" readOnly value={ac.d_A_Name3}/>   								 
                </FormGroup>
                 <FormGroup className="Col-5-4" label="ID No." labelFor="ID No.">
                    <InputGroup id="d_A_Idno1" name="d_A_Idno1" readOnly value={ac.d_A_Idno1}/>   
                    <InputGroup id="d_A_Idno2" name="d_A_Idno2" readOnly value={ac.d_A_Idno2}/>
                    <InputGroup id="d_A_Idno3" name="d_A_Idno3" readOnly value={ac.d_A_Idno3}/>
                </FormGroup>
                <FormGroup className="Col-9-4" label="Other Info." labelFor="Other Info.">
                    <InputGroup id="d_A_Idno1" name="d_A_Idno1" readOnly value={ac.d_Oth_Info1}/>   
                    <InputGroup id="d_A_Idno2" name="d_A_Idno1" readOnly value={ac.d_Oth_Info2}/>
                    <InputGroup id="d_A_Idno3" name="d_A_Idno1" readOnly value={ac.d_Oth_Info3}/>
                </FormGroup>
            </div>

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-6" label="Remark" labelFor="inputRemark">
                    <TextArea readOnly fill rows={4}  value={ac.d_A_Remarks}/>
                </FormGroup>
            </div>
            

        </>
    )
}







interface ClientAuthorPersonEditProps {
    gsb: AxiosInstance,
    ac?: Account,
    isNew?: boolean,
    onSave?: (stk: Account) => void,
    onCancel?: () => void,
}

export function ClientAuthorPersonEdit({ gsb, ac = {} as Account, isNew = false, onSave = () => { }, onCancel = () => { } }: ClientAuthorPersonEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<Account>()

    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)

    //const [Net, setNet] = useState(ac.d_Net ? "Y" : "N")
    //const [BankGran, setBankGran] = useState(ac.d_BankGran ? "Y" : "N")


    //const [ProFessionalInv, setProFessionalInv] = useState(ac.d_Professional_Investor ? "Y" : "N")
    //const [DiscretionIndicator, setDiscretionIndicator] = useState(ac.d_DiscretionIndicator ? "Y" : "N")
    //const [StaffRelated, setStaffRelated] = useState(ac.d_StaffRelated ? "Y" : "N")                

    //const [RiskLevel, setRiskLevel] = useState(ac.d_RiskLevel|| "L")              




    //const [Lang, setLang] = useState(ac.d_Lang || "E")
    //const [Confirm, setConfirm] = useState(ac.d_Confirm || "N")
    //const [SkipHCopy, setSkipHCopy] = useState(ac.d_SkipHCopy || "N")
    //const [SEmailD, setSEmailD] = useState(ac.d_SEmailD || "N")
    //const [SEmailM, setSEmailM] = useState(ac.d_SEmailM || "N")

    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

   
    useEffect(() => {
        // Call reset to get the values of record ClientTranInfo 
        if ("d_acCode" in ac) {
            reset(ac)
        }
    }, [ac, reset])
    
 

    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected      
       //register({ name: "d_footnote" })
    }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    
 //   if (! isNew && ! ("d_acCode" in ac)) return null

   
    const onSubmit = (data: Account) => {      

        data.d_AuthTran = ""
        if (isReqAuth) {
            data.d_AuthTran = "Y"
        }

        (async () => {
            try {
                const res = await gsb.post('/Master', {sb_data: data, cPgmId: "CLMast", cAction: "ClValidate2", isNew: isNew})

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }
                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }

             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Account" labelFor="d_acCode" labelInfo="*">
                    <InputGroup disabled={!isNew} id="d_acCode" name="d_acCode" defaultValue={ac.d_acCode} placeholder="Account ..." inputRef={register({ required: true , maxLength: 12}) } />
                    {errors.d_acCode && errors.d_acCode.type === "required" && <span id="Err_msg">Account cannot be Blank</span>}
                    {errors.d_acCode && errors.d_acCode.type === "maxLength" && <span id="Err_msg">Max length is 12</span>}
                    {errors.d_acCode && errors.d_acCode.types && <span id="Err_msg">{errors.d_acCode.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-3" label="Name" labelFor="d_Name">
                    <InputGroup disabled={!isNew} id="d_Name" name="d_Name" defaultValue={ac.d_acName1} placeholder="" inputRef={register({ maxLength: 40}) } />
                    {errors.d_acName1 && errors.d_acName1.type === "maxLength" && <span id="Err_msg">Max length is 40</span>}
                    {errors.d_acName1 && errors.d_acName1.types && <span id="Err_msg">{errors.d_acName1.types.message}</span>}
                    <InputGroup disabled={!isNew} id="d_Name2" name="d_Name2" defaultValue={ac.d_acName2} placeholder="" inputRef={register({ maxLength: 40}) } />
                    {errors.d_acName2 && errors.d_acName2.type === "maxLength" && <span id="Err_msg">Max length is 40</span>}
                    {errors.d_acName2 && errors.d_acName2.types && <span id="Err_msg">{errors.d_acName2.types.message}</span>}
                </FormGroup> 
            </div>
          
            <div className="Row">
                <FormGroup className="Col-1-4" label="Name1" labelFor="Name1">
                    <InputGroup id="d_A_Name1" name="d_A_Name1" defaultValue={ac.d_A_Name1} placeholder="Name1 ..." inputRef={register({ maxLength: 40}) } />
                    {errors.d_A_Name1 && errors.d_A_Name1.type === "maxLength" && <span id="Err_msg">Max length is 40</span>}
                    {errors.d_A_Name1 && errors.d_A_Name1.types && <span id="Err_msg">{errors.d_A_Name1.types.message}</span>}

                    <InputGroup id="d_A_Name2" name="d_A_Name2" defaultValue={ac.d_A_Name2} placeholder="Name2 ..." inputRef={register({ maxLength: 40}) } />
                    {errors.d_A_Name2 && errors.d_A_Name2.type === "maxLength" && <span id="Err_msg">Max length is 40</span>}
                    {errors.d_A_Name2 && errors.d_A_Name2.types && <span id="Err_msg">{errors.d_A_Name2.types.message}</span>}

                    <InputGroup id="d_A_Name3" name="d_A_Name3" defaultValue={ac.d_A_Name3} placeholder="Name3 ..." inputRef={register({ maxLength: 40}) } />
                    {errors.d_A_Name3 && errors.d_A_Name3.type === "maxLength" && <span id="Err_msg">Max length is 40</span>}
                    {errors.d_A_Name3 && errors.d_A_Name3.types && <span id="Err_msg">{errors.d_A_Name3.types.message}</span>}
  
                </FormGroup>
                 <FormGroup className="Col-5-4" label="ID No." labelFor="ID No.">
                    <InputGroup id="d_A_Idno1" name="d_A_Idno1" defaultValue={ac.d_A_Idno1} placeholder="Idno1 ..." inputRef={register({ maxLength: 20}) } />
                    {errors.d_A_Idno1 && errors.d_A_Idno1.type === "maxLength" && <span id="Err_msg">Max length is 20</span>}
                    {errors.d_A_Idno1 && errors.d_A_Idno1.types && <span id="Err_msg">{errors.d_A_Idno1.types.message}</span>}

                    <InputGroup id="d_A_Idno2" name="d_A_Idno2" defaultValue={ac.d_A_Idno2} placeholder="Idno1 ..." inputRef={register({ maxLength: 20}) } />
                    {errors.d_A_Idno2 && errors.d_A_Idno2.type === "maxLength" && <span id="Err_msg">Max length is 20</span>}
                    {errors.d_A_Idno2 && errors.d_A_Idno2.types && <span id="Err_msg">{errors.d_A_Idno2.types.message}</span>}

                    <InputGroup id="d_A_Idno3" name="d_A_Idno3" defaultValue={ac.d_A_Idno3} placeholder="Idno3 ..." inputRef={register({ maxLength: 20}) } />
                    {errors.d_A_Idno3 && errors.d_A_Idno3.type === "maxLength" && <span id="Err_msg">Max length is 20</span>}
                    {errors.d_A_Idno3 && errors.d_A_Idno3.types && <span id="Err_msg">{errors.d_A_Idno3.types.message}</span>}
  
                </FormGroup>

                <FormGroup className="Col-9-4" label="Other Info." labelFor="Other Info.">
                    <InputGroup id="d_Oth_Info1" name="d_Oth_Info1" defaultValue={ac.d_Oth_Info1} placeholder="Oth_Info1 ..." inputRef={register({ maxLength: 80}) } />
                    {errors.d_Oth_Info1 && errors.d_Oth_Info1.type === "maxLength" && <span id="Err_msg">Max length is 80</span>}
                    {errors.d_Oth_Info1 && errors.d_Oth_Info1.types && <span id="Err_msg">{errors.d_Oth_Info1.types.message}</span>}

                    <InputGroup id="d_Oth_Info2" name="d_Oth_Info2" defaultValue={ac.d_Oth_Info2} placeholder="Oth_Info2 ..." inputRef={register({ maxLength: 80}) } />
                    {errors.d_Oth_Info2 && errors.d_Oth_Info2.type === "maxLength" && <span id="Err_msg">Max length is 80</span>}
                    {errors.d_Oth_Info2 && errors.d_Oth_Info2.types && <span id="Err_msg">{errors.d_Oth_Info2.types.message}</span>}

                    <InputGroup id="d_Oth_Info3" name="d_Oth_Info3" defaultValue={ac.d_Oth_Info3} placeholder="Oth_Info3 ..." inputRef={register({ maxLength: 80}) } />
                    {errors.d_Oth_Info3 && errors.d_Oth_Info3.type === "maxLength" && <span id="Err_msg">Max length is 80</span>}
                    {errors.d_Oth_Info3 && errors.d_Oth_Info3.types && <span id="Err_msg">{errors.d_Oth_Info3.types.message}</span>}  
                </FormGroup>
            </div>

        
            <div className="Spacing-V-16" />
            <div className="Row">
                {/* <textarea className="bp4-input bp4-fill Col-1-6" name="d_footnote" rows={5} ref={register}></textarea> */}
                <FormGroup className="Col-1-6" label="Remark" labelFor="inputRemark"> 
                    <textarea className="bp4-input bp4-fill" name="d_A_Remarks" rows={4}  ref={register}  maxLength={160} ></textarea>
                    {errors.d_A_Remarks && errors.d_A_Remarks.type === "maxLength" && <span id="Err_msg">Max length is 80</span>}
                    {errors.d_A_Remarks && errors.d_A_Remarks.types && <span id="Err_msg">{errors.d_A_Remarks.types.message}</span>}  
                </FormGroup>
            </div>
        </form>
    )
}

interface ClientAuthorPersonMainProps {
    gsb: AxiosInstance
}

// const toaster = Toaster.create({
//     position: Position.TOP,
// })

function ClientAuthorPersonMain({ gsb }: ClientAuthorPersonMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { comdy: defaultSearchValue = "" }: { comdy: string, dmon: string } = useParams()

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as Account[])

    const [searchKey, setSearchKey] = useState("acct")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentAc, setCurrentAc] = useState({} as Account)

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    const [ViewMode, setViewMode] = useState("V")
    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 


 
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                UserID = res.data.Flag.UserID
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])



    const PrevRecProcess = async (ac: Account) => {
        try {
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "PrevRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (ac: Account) => {
        try {
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "DelRec"})
            utils.showSuccess("Account " + ac.d_acCode + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (ac: Account) => {
        try {
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (ac: Account) => {
        try {
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "AddRec"})
            utils.showSuccess("Account " + ac.d_acCode + " record added")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (ac: Account) => {
        try {
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "UpdateRec"})
            utils.showSuccess("Account " + ac.d_acCode + " record saved")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    console.log("editOnSave data", i, data)
                    setData(data)
                    break
                }
            }
            console.log("editOnSave res.data.data", res.data.data)
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }
 
    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        try {
            console.log("CLMastMain onsubmit called1", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                        }, 
                    },
                    cPgmId: "CLMast",
                    cAction: "ListRec",
                });

               
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        d_acCode: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "CLMast",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    
                    setCurrentAc(res.data.data)
                    setCurrentMode("show")
                } else {
                  
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }
 



    
    {/*
    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("CLMastMain useEffect length > 0  called", data)
                const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: "acct",
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "CLMast",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])
    */}

    //Press page No 1 2 3 4
    {/*
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                            }, 
                        },
                        cPgmId: "CLMast",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setCurrentAc(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    */}

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    // currentMode = show

    let detail = <ClientAuthorPersonView gsb={gsb} ac={currentAc}   baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ></ClientAuthorPersonView>
      
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <ClientAuthorPersonEdit gsb={gsb} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></ClientAuthorPersonEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <ClientAuthorPersonEdit gsb={gsb} ac={currentAc} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></ClientAuthorPersonEdit>
            break
        }

    let pagination = <Pagination nPage={nPage} nTotalPage={nTotalPage} aPageNumber={aPageNumber} setnPage={(n)=>setnPage(n)}></Pagination>
    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-100">Account</th>
                <th className="TCol-60">Type</th>
                <th className="TCol-300">Name</th>
                <th className="TCol-100">Runner</th>
                <th className="TCol-120">A/C open Date</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((ac, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td onClick={() => { setCurrentAc(ac) ; MoblieDev && setSelectedTabId("detail") }}>{ac.d_acCode}</td>
                        <td onClick={() => { setCurrentAc(ac) ; MoblieDev && setSelectedTabId("detail") }}>{ac.d_status}</td>
                        <td onClick={() => { setCurrentAc(ac) ; MoblieDev && setSelectedTabId("detail") }}>{ac.d_acName1}</td>
                        <td onClick={() => { setCurrentAc(ac) ; MoblieDev && setSelectedTabId("detail") }}>{ac.d_aeCode}</td>
                        <td onClick={() => { setCurrentAc(ac) ; MoblieDev && setSelectedTabId("detail") }}>{utils.isEmptyDate(ac.d_openDate) ? "ACTIVE" : "CLOSED"}</td>
                        {/* <td onClick={() => { setCurrentAc(ac) }}>{ac.d_Action}</td> */}
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Account Information</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* define search key */}
                        <FormGroup className="Col-1-5" label="Search for" labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="acct">Account</option>
                                    <option value="name">Name</option>
                                    <option value="runner">A/E</option>
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "acct"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "acct"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        </div>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card>

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default ClientAuthorPersonMain



interface  ClClientAuthorPersonViewProps {
    gsb: AxiosInstance,
    acCode:  any, 
}

export function ClClientAuthorPersonView({ gsb, acCode }: ClClientAuthorPersonViewProps) { 
 
     const { t, i18n } = useTranslation();     
     const [isReadOnly, setisReadOnly] = useState(false)
     const [isReqAuth, setisReqAuth] = useState(true)
     const [isDeletePress, setisDeletePress] = useState(false) 
     const [AuthUser, setAuthUser] = useState("")
     const [password, setPassword] = useState("") 
     const [isHKIDRPress, setisHKIDRPress] = useState(false)
     const [isHKCRSPress, setisHKCRSPress] = useState(false)
     const [isAuhorPersonPress, setisAuhorPersonPress] = useState(false) 
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [isViewClientDoc, setisViewClientDoc] = useState(false)
    const [isViewClientDocPress, setisViewClientDocPress] = useState(false)   
    const [isManageClientDocPress, setisManageClientDocPress] = useState(false)
    const [showClientDoc, setshowClientDoc] = useState(true)
    const [isUploadDocPress, setisUploadDocPress] = useState(false)
    const [reloadDoc, setreloadDoc] = useState(false)
    const [docList, setDocList] = useState([] as Document[])
    const [isManageClientDoc, setisManageClientDoc] = useState(false)

    const [isForeignCurrencyPress, setisForeignCurrencyPress] = useState(false)
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [Enter2tab, setEnter2tab] = useState("Y")
    const [data, setData] = useState([] as Account[])
    const [currentAc, setCurrentAc] = useState({} as Account)
    const [BlankAc, setBlankAc] = useState({} as Account)
    const [currentMode, setCurrentMode] = useState("show") 

 
     useEffect(() => {
         (async () => {
             try {
                 // get GsbFlag from SB.XBS
                 const res = await gsb.post('/GsbFlag');
                 GsbFlag = res.data.Flag;
                
                 UserID = res.data.Flag.UserID
 
                 if (GsbFlag.isProduction == "Y") {
                     setcardOpen01("cardOpen01-Theme" + GsbFlag.DEF_THEME1);
                 } else {
                     setcardOpen01("cardOpen01-Theme" + GsbFlag.DEF_THEME2);
                 }
                 setEnter2tab(GsbFlag.Enter2tab);
                  
             } catch (error) {
                 utils.showError(error)
             }
         })()
     }, [gsb])
 
     
 /*
     useEffect(() => {
         if ( GsbFlag.Enter2tab == "Y" ) {
             let inputs = utils.PerformEnter2Tab()
         }
     }, [])
 */
 
     
    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            //setisReqAuth(true)
                            //isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, acCode])
 

    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        d_acCode:acCode,
                        nPage: 1,
                        limit: 1,                       
                    },
                    cPgmId: "CLMast",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    console.log("GetRec res.data.data", res.data.data)
                    setCurrentAc(res.data.data)
                    setCurrentMode("show")
                } else {
                    
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [  ])
 
     const onReqViewClientDoc = () => {
         (async () => {
             try {
                 const res2 = await gsb.post('/PgmAccess', {
                     userId: AuthUser,
                     password: password,
                     cIPAddr: "",
                     cReqUser: GsbFlag.UserID,
                 } )
                 if (res2.data.ok) {
                     setAuthUser("")
                     setPassword("")
 
                     const res = await gsb.post('/Master', {
                         sb_data: {
                             userId: AuthUser,
                             password: password,
                         }, 
                         cPgmId: "UserPgmAccess", 
                         cAction: "ReqUserGroupAccessReqAuth"
                     })
                     console.log("onReqAuthDelRec res.data.data", res.data.data);
                     if ( res.data.ok && res.data.data[0].d_Can_ViewClientDoc == "Y") {
                         setshowClientDoc(true);
                         
                     } else {
                         utils.showWarn("Authorization failed")
                         setisShowAlert2(true)
                         setShowAlert2Msg("Authorization failed")
                     }
 
                 } else {
                     utils.showError(res2.data.message)
                     setisShowAlert2(true)
                     setShowAlert2Msg(res2.data.message)
                 }
             } catch (error) {
                 utils.showError(error)
             }
         })()
 
     }
 
 
 
    const PrevRecProcess = async (ac: Account) => {
        try {
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "PrevRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }
    const NextRecProcess = async (ac: Account) => {
        try {
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (ac: Account) => {
        try {
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "DelRec"})
            utils.showSuccess("Account " + ac.d_acCode + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }
 
    const newOnSave = async (ac: Account) => {
        try {
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "AddRec"})
            utils.showSuccess("Account " + ac.d_acCode + " record added")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (ac: Account) => {
        try {
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "UpdateRec"})
            utils.showSuccess("Account " + ac.d_acCode + " record saved")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                // console.log("editOnSave data", i, data)
                    setData(data)
                    
                    break
                }
            }
        //console.log("editOnSave res.data.data", res.data.data)
        setCurrentAc(res.data.data)
        setCurrentMode("show")
            
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    } 
  
 
    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

// if (! ("d_acCode" in acCode)) return null

    let detail = <ClientAuthorPersonView gsb={gsb} ac={currentAc}  baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ></ClientAuthorPersonView>
    switch (currentMode) {
 
        case "edit":
            console.log("currentMode = edit")
            detail = <ClientAuthorPersonEdit gsb={gsb} ac={currentAc} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></ClientAuthorPersonEdit>
            break
        case "new":
            console.log("currentMode = new")
            detail = <ClientAuthorPersonEdit gsb={gsb} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show")} }></ClientAuthorPersonEdit>
            break            
        }

        return (
            
        <>
            <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >            
                <div><H3>Authorization Person</H3></div>

                {detail}
                <div className="Spacing-V-16" />
            </Card>
            <div className="Spacing-V-16"></div>
            <div className="Spacing-V-16"></div>
            <Alert
                confirmButtonText="OK"
                icon="tick-circle"
                intent={Intent.SUCCESS}
                isOpen={isShowAlert1}
                onCancel={ () => setisShowAlert1(false) }
                onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
            >
                <p>
                    {ShowAlert1Msg}
                </p>
            </Alert>
            <Alert
                confirmButtonText="OK"
                icon="cross"
                intent={Intent.WARNING}
                isOpen={isShowAlert2}
                onCancel={ () => setisShowAlert2(false) }
                onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
            >
                <p>
                    {ShowAlert2Msg}
                </p>
            </Alert>
        </>
        
 
  
     )
 }
 